class NextAppointmentModalCtrl {
    constructor(modalContext,
                slicesService,
                AfspraakMogelijkheidTypes,
                AgendaOverzicht,
                praktijkContext,
                NextAppointmentApi,
                $scope) {
        'ngInject';

        this.slicesService = slicesService;
        this.context = modalContext;
        this.modalDate = this.slicesService.slicesLoader.criteria.dag;
        this.AfspraakMogelijkheidTypes = AfspraakMogelijkheidTypes;
        this.AgendaOverzicht = AgendaOverzicht;
        this.NextAppointmentApi = NextAppointmentApi;
        this.availabilityResults = [];
        this.allTypes = [];
        this.modalScope = $scope;
        this.isUpdating = false;
        this.shouldUpdate = false;
        this.allType = {
            naam_nl: 'Alle',
            naam_en: 'all',
            id: 'gg'
        }
        this.appointmentPublicKindValues = ['all', 'publicVisible', 'publicNotVisible'];
        this.selectedAppointmentKind = 'all';
        this.selectedType = this.allType;
        this.afspraakTypes = [this.allType];

        window.setTimeout(() => {
            AfspraakMogelijkheidTypes.getTypes(praktijkContext.id)
                .then((types) => this._setTypes(types))
                .then(() =>  AgendaOverzicht.get(praktijkContext.id))
                .then((calendars) => this.availabilityResults = calendars.map(calendar => {return { calendar}}))
                .then(() => this.availabilityResults.sort((x,y) => x.calendar.volgnummer < y.calendar.volgnummer ? -1: 1))
                .then(() => this.update());
        }, 20)
    }



    update(){
        if(!this.modalDate || !this.selectedType){
            return;
        }

        if(this.isUpdating){
            this.needsUpdate = true;
            return;
        }

        this.needsUpdate = false;
        this.isUpdating = true;

        this.availabilityResults.forEach((availabilityResult) => this._loadAvailability(availabilityResult));

        window.setTimeout(() => {
            this.isUpdating = false;
            if(this.needsUpdate){
                this.update();
            }
        }, 1000)

    }

    showAvailability(availability){
        let av = availability.availability;
        this.slicesService.slicesLoader.navigator.wijzigDagEnAgenda(av.day, av.calendarId, av.appointmentId);
        this.modalScope.$close();
    }

    onChangeAppointmentKind(){
        this.afspraakTypes = this.allTypes.filter(type=>{

            if(typeof type.zichtbaar_voor_patient === "undefined"){
                return true;
            }

            if(this.selectedAppointmentKind === 'all'){
                return true;
            }

            if(this.selectedAppointmentKind === 'publicVisible'){
                return type.zichtbaar_voor_patient !== 'nee';
            }

            if(this.selectedAppointmentKind === 'publicNotVisible'){
                return type.zichtbaar_voor_patient === 'nee';
            }

            return false;
        });

        if(this.afspraakTypes.filter(x=> x.id === this.selectedType.id).length === 0){
            this.selectedType = this.allType;
        }

        this.update();
    }

    _setTypes(types) {
        let metAfspraakmogelijkheden = types.filter(type => type.met_afspraakmogelijkheden);
        this.allTypes = metAfspraakmogelijkheden;
        metAfspraakmogelijkheden.unshift(this.allType);
        this.afspraakTypes = metAfspraakmogelijkheden;
    }

    _loadAvailability(availabilityResult) {

        availabilityResult.availability = undefined;
        availabilityResult.loading = true;

        let nextAppointmentCriteria =  {
            discipline: undefined,
            fromDay: this.modalDate,
            calendarId: availabilityResult.calendar.uuid,
            appointmentKind: this.selectedAppointmentKind,
            appointmentType: this.selectedType.id === this.allType.id ? undefined : this.selectedType.id,
        };

        this.NextAppointmentApi.searchNextAppointment(nextAppointmentCriteria)
            .then((av) => {
                availabilityResult.availability = av;
                availabilityResult.loading = false;
            });
    }
}
